export { PracticeInfoComponent } from './PracticeInfoComponent';
